import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { gruhUdhyogVariantService } from "@project/services/admin/gruh-udhyog-variant.service";
import type {
  ProductVariantMaster,
  ProductVariantMasterPayload,
} from "@project/types/gruh-udhyog";

const fields: Field[] = [
  {
    name: "title",
    label: "Title",
    required: true,
    showInTable: true,
    placeholder: "e.g. Weight",
  },
  {
    name: "values",
    label: "Values",
    type: "tags",
    required: true,
    showInTable: true,
    placeholder: "Type and press Enter...",
    help: "Press Enter or comma to add a value",
  },
  {
    name: "is_active",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(
  payload: Record<string, unknown>
): ProductVariantMasterPayload {
  let vals: string[] = [];
  if (Array.isArray(payload.values)) {
    vals = payload.values.map(String);
  } else if (typeof payload.values === "string" && payload.values.trim()) {
    vals = payload.values
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  }
  return {
    title: String(payload.title ?? "").trim(),
    values: vals,
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function ProductVariantsPage() {
  return (
    <AdminShell
      title="Product Variants"
      subtitle="Manage product packaging, sizes, and pricing"
    >
      <ApiResourceTable<ProductVariantMaster>
        title="Variant Master"
        labelField="title"
        fields={fields}
        searchFields={["title"]}
        defaultValues={{ is_active: true, values: [] }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        csvFileName="product-variant-masters"
        list={query => gruhUdhyogVariantService.listPage(query)}
        loadRecordForEdit={id => gruhUdhyogVariantService.get(id)}
        create={payload => gruhUdhyogVariantService.create(toPayload(payload))}
        update={(id, payload) =>
          gruhUdhyogVariantService.update(id, toPayload(payload))
        }
        remove={id => gruhUdhyogVariantService.delete(id)}
      />
    </AdminShell>
  );
}
